import React from 'react';
import useStyles from './styles/registrationForm';
import { useTypeSelector } from '../../hooks/useTypesSelector';

export const RegistrationDescription = () => {
  const classes = useStyles();
  const description = useTypeSelector((s) => s.registration.description);
  return <h5 className={classes.h5}>{description}</h5>;
};
